import script from "./ErrorHandler.vue?vue&type=script&lang=js"
export * from "./ErrorHandler.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__